import { Component, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'language-proficiency-modal',
  templateUrl: 'language.proficiency.modal.html',
})
export class LanguageProficiencyModal {
  constructor(
    public dialogRef: MatDialogRef<LanguageProficiencyModal>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  leaveDialog() {
    this.dialogRef.disableClose = false;
  }
  openDialog() {
    this.dialogRef.disableClose = true;
  }
}
